import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'male-al',
	landing: {
		ids: ['loader-m'],
		route: {
			path: '/m-al',
			name: 'male-funnel-al',
		},
	},
	funnel: {
		id: 'ob-male-funnel-al',
		route: {
			path: '/m-al/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'male-al-survey',
		},
		slug: 'male-al',
		theme: 'navy',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-m',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-m'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
